/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRouteDto,
  RouteArchivePrecheckDto,
  RouteArchiveResultDto,
  RouteDetailDto,
  RouteListItemDto,
  RouteUpdatePrecheckDto,
  RoutesControllerListRoutesParams,
  UpdateRouteDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type routesControllerListRoutesResponse200 = {
  data: RouteListItemDto[]
  status: 200
}

export type routesControllerListRoutesResponse401 = {
  data: void
  status: 401
}

export type routesControllerListRoutesResponse403 = {
  data: void
  status: 403
}

export type routesControllerListRoutesResponseSuccess = (routesControllerListRoutesResponse200) & {
  headers: Headers;
};
export type routesControllerListRoutesResponseError = (routesControllerListRoutesResponse401 | routesControllerListRoutesResponse403) & {
  headers: Headers;
};

export type routesControllerListRoutesResponse = (routesControllerListRoutesResponseSuccess | routesControllerListRoutesResponseError)

export const getRoutesControllerListRoutesUrl = (partnerId: string,
    params?: RoutesControllerListRoutesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/routes?${stringifiedParams}` : `/partners/${partnerId}/routes`
}

/**
 * Returns the partner’s routes with their checkpoint counts, active routes first then by name. Archived routes are excluded unless include_archived=true.
 * @summary List routes for a partner
 */
export const routesControllerListRoutes = async (partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerListRoutesResponse> => {

  return customFetch<routesControllerListRoutesResponse>(getRoutesControllerListRoutesUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRoutesControllerListRoutesQueryKey = (partnerId: string,
    params?: RoutesControllerListRoutesParams,) => {
    return [
    `/partners/${partnerId}/routes`, ...(params ? [params] : [])
    ] as const;
    }


export const getRoutesControllerListRoutesQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerListRoutesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerListRoutes>>> = ({ signal }) => routesControllerListRoutes(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerListRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerListRoutes>>>
export type RoutesControllerListRoutesQueryError = void


export function useRoutesControllerListRoutes<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params: undefined |  RoutesControllerListRoutesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerListRoutes>>,
          TError,
          Awaited<ReturnType<typeof routesControllerListRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerListRoutes<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerListRoutes>>,
          TError,
          Awaited<ReturnType<typeof routesControllerListRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerListRoutes<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List routes for a partner
 */

export function useRoutesControllerListRoutes<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerListRoutesQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List routes for a partner
 */
export const prefetchRoutesControllerListRoutesQuery = async <TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRoutesControllerListRoutesQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getRoutesControllerListRoutesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerListRoutesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerListRoutes>>> = ({ signal }) => routesControllerListRoutes(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerListRoutesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerListRoutes>>>
export type RoutesControllerListRoutesSuspenseQueryError = void


export function useRoutesControllerListRoutesSuspense<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params: undefined |  RoutesControllerListRoutesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerListRoutesSuspense<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerListRoutesSuspense<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List routes for a partner
 */

export function useRoutesControllerListRoutesSuspense<TData = Awaited<ReturnType<typeof routesControllerListRoutes>>, TError = void>(
 partnerId: string,
    params?: RoutesControllerListRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerListRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerListRoutesSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type routesControllerCreateRouteResponse201 = {
  data: RouteDetailDto
  status: 201
}

export type routesControllerCreateRouteResponse400 = {
  data: void
  status: 400
}

export type routesControllerCreateRouteResponse401 = {
  data: void
  status: 401
}

export type routesControllerCreateRouteResponse403 = {
  data: void
  status: 403
}

export type routesControllerCreateRouteResponse409 = {
  data: void
  status: 409
}

export type routesControllerCreateRouteResponseSuccess = (routesControllerCreateRouteResponse201) & {
  headers: Headers;
};
export type routesControllerCreateRouteResponseError = (routesControllerCreateRouteResponse400 | routesControllerCreateRouteResponse401 | routesControllerCreateRouteResponse403 | routesControllerCreateRouteResponse409) & {
  headers: Headers;
};

export type routesControllerCreateRouteResponse = (routesControllerCreateRouteResponseSuccess | routesControllerCreateRouteResponseError)

export const getRoutesControllerCreateRouteUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/routes`
}

/**
 * Creates a route in ONE factory (ENG-743) with its ordered checkpoints (array order becomes checkpoint_order 1..n). Every checkpoint must lie inside the route’s factory, optionally narrowed to a zone and then a station. The first route created in a factory automatically becomes its default; is_default:true takes the tag off the current holder. product_type_option_ids scopes the route ("Make this route available for") — omitted or empty means ALL product types.
 * @summary Create a route
 */
export const routesControllerCreateRoute = async (partnerId: string,
    createRouteDto: CreateRouteDto, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerCreateRouteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<routesControllerCreateRouteResponse>(getRoutesControllerCreateRouteUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRouteDto)
  }
);}





export const getRoutesControllerCreateRouteMutationKey = () => ['routesControllerCreateRoute'] as const;

export const getRoutesControllerCreateRouteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerCreateRoute>>, TError,RoutesControllerCreateRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof routesControllerCreateRoute>>, TError,RoutesControllerCreateRouteMutationVariables, TContext> => {

const mutationKey = getRoutesControllerCreateRouteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routesControllerCreateRoute>>, RoutesControllerCreateRouteMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  routesControllerCreateRoute(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoutesControllerCreateRouteMutationResult = NonNullable<Awaited<ReturnType<typeof routesControllerCreateRoute>>>
    export type RoutesControllerCreateRouteMutationBody = CreateRouteDto
    export type RoutesControllerCreateRouteMutationError = void
    export type RoutesControllerCreateRouteMutationVariables = {partnerId: string;data: CreateRouteDto}

    /**
 * @summary Create a route
 */
export const useRoutesControllerCreateRoute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerCreateRoute>>, TError,RoutesControllerCreateRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routesControllerCreateRoute>>,
        TError,
        RoutesControllerCreateRouteMutationVariables,
        TContext
      > => {
      return useMutation(getRoutesControllerCreateRouteMutationOptions(options), queryClient);
    }
    export type routesControllerGetRouteResponse200 = {
  data: RouteDetailDto
  status: 200
}

export type routesControllerGetRouteResponse401 = {
  data: void
  status: 401
}

export type routesControllerGetRouteResponse403 = {
  data: void
  status: 403
}

export type routesControllerGetRouteResponse404 = {
  data: void
  status: 404
}

export type routesControllerGetRouteResponseSuccess = (routesControllerGetRouteResponse200) & {
  headers: Headers;
};
export type routesControllerGetRouteResponseError = (routesControllerGetRouteResponse401 | routesControllerGetRouteResponse403 | routesControllerGetRouteResponse404) & {
  headers: Headers;
};

export type routesControllerGetRouteResponse = (routesControllerGetRouteResponseSuccess | routesControllerGetRouteResponseError)

export const getRoutesControllerGetRouteUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}`
}

/**
 * Returns the route and its checkpoints in order, each with resolved factory / zone / station display names.
 * @summary Get a route with its checkpoints
 */
export const routesControllerGetRoute = async (partnerId: string,
    routeId: string, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerGetRouteResponse> => {

  return customFetch<routesControllerGetRouteResponse>(getRoutesControllerGetRouteUrl(partnerId,routeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRoutesControllerGetRouteQueryKey = (partnerId: string,
    routeId: string,) => {
    return [
    `/partners/${partnerId}/routes/${routeId}`
    ] as const;
    }


export const getRoutesControllerGetRouteQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerGetRouteQueryKey(partnerId,routeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerGetRoute>>> = ({ signal }) => routesControllerGetRoute(partnerId,routeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && routeId !== null && routeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerGetRouteQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerGetRoute>>>
export type RoutesControllerGetRouteQueryError = void


export function useRoutesControllerGetRoute<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerGetRoute>>,
          TError,
          Awaited<ReturnType<typeof routesControllerGetRoute>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerGetRoute<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerGetRoute>>,
          TError,
          Awaited<ReturnType<typeof routesControllerGetRoute>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerGetRoute<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a route with its checkpoints
 */

export function useRoutesControllerGetRoute<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerGetRouteQueryOptions(partnerId,routeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a route with its checkpoints
 */
export const prefetchRoutesControllerGetRouteQuery = async <TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRoutesControllerGetRouteQueryOptions(partnerId,routeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getRoutesControllerGetRouteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerGetRouteQueryKey(partnerId,routeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerGetRoute>>> = ({ signal }) => routesControllerGetRoute(partnerId,routeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerGetRouteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerGetRoute>>>
export type RoutesControllerGetRouteSuspenseQueryError = void


export function useRoutesControllerGetRouteSuspense<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerGetRouteSuspense<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerGetRouteSuspense<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a route with its checkpoints
 */

export function useRoutesControllerGetRouteSuspense<TData = Awaited<ReturnType<typeof routesControllerGetRoute>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerGetRoute>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerGetRouteSuspenseQueryOptions(partnerId,routeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type routesControllerUpdateRouteResponse200 = {
  data: RouteDetailDto
  status: 200
}

export type routesControllerUpdateRouteResponse400 = {
  data: void
  status: 400
}

export type routesControllerUpdateRouteResponse401 = {
  data: void
  status: 401
}

export type routesControllerUpdateRouteResponse403 = {
  data: void
  status: 403
}

export type routesControllerUpdateRouteResponse404 = {
  data: void
  status: 404
}

export type routesControllerUpdateRouteResponse409 = {
  data: void
  status: 409
}

export type routesControllerUpdateRouteResponseSuccess = (routesControllerUpdateRouteResponse200) & {
  headers: Headers;
};
export type routesControllerUpdateRouteResponseError = (routesControllerUpdateRouteResponse400 | routesControllerUpdateRouteResponse401 | routesControllerUpdateRouteResponse403 | routesControllerUpdateRouteResponse404 | routesControllerUpdateRouteResponse409) & {
  headers: Headers;
};

export type routesControllerUpdateRouteResponse = (routesControllerUpdateRouteResponseSuccess | routesControllerUpdateRouteResponseError)

export const getRoutesControllerUpdateRouteUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}`
}

/**
 * Renames the route, updates its description, replaces its checkpoints wholesale, replaces its product-type scope (empty array = ALL product types), and/or moves the factory-default tag onto it (is_default:true — the tag can only be moved, never switched off; the route’s factory itself is immutable). Narrowing the scope clears the route from incompatible draft/redrafting/scheduled work orders, and — when the route is or becomes the factory default — clears the factory from incompatible DRAFTING work orders (ENG-743 §14/§15). Call update-precheck first to show the confirmation counts. Archived routes cannot be edited (409).
 * @summary Update a route
 */
export const routesControllerUpdateRoute = async (partnerId: string,
    routeId: string,
    updateRouteDto: UpdateRouteDto, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerUpdateRouteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<routesControllerUpdateRouteResponse>(getRoutesControllerUpdateRouteUrl(partnerId,routeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRouteDto)
  }
);}





export const getRoutesControllerUpdateRouteMutationKey = () => ['routesControllerUpdateRoute'] as const;

export const getRoutesControllerUpdateRouteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdateRoute>>, TError,RoutesControllerUpdateRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdateRoute>>, TError,RoutesControllerUpdateRouteMutationVariables, TContext> => {

const mutationKey = getRoutesControllerUpdateRouteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routesControllerUpdateRoute>>, RoutesControllerUpdateRouteMutationVariables> = (props) => {
          const {partnerId,routeId,data} = props ?? {};

          return  routesControllerUpdateRoute(partnerId,routeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoutesControllerUpdateRouteMutationResult = NonNullable<Awaited<ReturnType<typeof routesControllerUpdateRoute>>>
    export type RoutesControllerUpdateRouteMutationBody = UpdateRouteDto
    export type RoutesControllerUpdateRouteMutationError = void
    export type RoutesControllerUpdateRouteMutationVariables = {partnerId: string;routeId: string;data: UpdateRouteDto}

    /**
 * @summary Update a route
 */
export const useRoutesControllerUpdateRoute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdateRoute>>, TError,RoutesControllerUpdateRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routesControllerUpdateRoute>>,
        TError,
        RoutesControllerUpdateRouteMutationVariables,
        TContext
      > => {
      return useMutation(getRoutesControllerUpdateRouteMutationOptions(options), queryClient);
    }
    export type routesControllerUpdatePrecheckResponse200 = {
  data: RouteUpdatePrecheckDto
  status: 200
}

export type routesControllerUpdatePrecheckResponse400 = {
  data: void
  status: 400
}

export type routesControllerUpdatePrecheckResponse401 = {
  data: void
  status: 401
}

export type routesControllerUpdatePrecheckResponse403 = {
  data: void
  status: 403
}

export type routesControllerUpdatePrecheckResponse404 = {
  data: void
  status: 404
}

export type routesControllerUpdatePrecheckResponse409 = {
  data: void
  status: 409
}

export type routesControllerUpdatePrecheckResponseSuccess = (routesControllerUpdatePrecheckResponse200) & {
  headers: Headers;
};
export type routesControllerUpdatePrecheckResponseError = (routesControllerUpdatePrecheckResponse400 | routesControllerUpdatePrecheckResponse401 | routesControllerUpdatePrecheckResponse403 | routesControllerUpdatePrecheckResponse404 | routesControllerUpdatePrecheckResponse409) & {
  headers: Headers;
};

export type routesControllerUpdatePrecheckResponse = (routesControllerUpdatePrecheckResponseSuccess | routesControllerUpdatePrecheckResponseError)

export const getRoutesControllerUpdatePrecheckUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}/update-precheck`
}

/**
 * Read-only dry run of PATCH with the same body: counts the work orders that would lose this route (product type outside the proposed scope; draft/redrafting/scheduled only — In Progress/Completed always keep it) and the DRAFTING work orders that would lose their factory (this route is or becomes the factory default and can’t build their product type). Also names the route the default tag would move off. Nothing is written.
 * @summary Pre-check a route update (ENG-743 §14/§15 confirmation counts)
 */
export const routesControllerUpdatePrecheck = async (partnerId: string,
    routeId: string,
    updateRouteDto: UpdateRouteDto, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerUpdatePrecheckResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<routesControllerUpdatePrecheckResponse>(getRoutesControllerUpdatePrecheckUrl(partnerId,routeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRouteDto)
  }
);}





export const getRoutesControllerUpdatePrecheckMutationKey = () => ['routesControllerUpdatePrecheck'] as const;

export const getRoutesControllerUpdatePrecheckMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>, TError,RoutesControllerUpdatePrecheckMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>, TError,RoutesControllerUpdatePrecheckMutationVariables, TContext> => {

const mutationKey = getRoutesControllerUpdatePrecheckMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>, RoutesControllerUpdatePrecheckMutationVariables> = (props) => {
          const {partnerId,routeId,data} = props ?? {};

          return  routesControllerUpdatePrecheck(partnerId,routeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoutesControllerUpdatePrecheckMutationResult = NonNullable<Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>>
    export type RoutesControllerUpdatePrecheckMutationBody = UpdateRouteDto
    export type RoutesControllerUpdatePrecheckMutationError = void
    export type RoutesControllerUpdatePrecheckMutationVariables = {partnerId: string;routeId: string;data: UpdateRouteDto}

    /**
 * @summary Pre-check a route update (ENG-743 §14/§15 confirmation counts)
 */
export const useRoutesControllerUpdatePrecheck = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>, TError,RoutesControllerUpdatePrecheckMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routesControllerUpdatePrecheck>>,
        TError,
        RoutesControllerUpdatePrecheckMutationVariables,
        TContext
      > => {
      return useMutation(getRoutesControllerUpdatePrecheckMutationOptions(options), queryClient);
    }
    export type routesControllerArchivePrecheckResponse200 = {
  data: RouteArchivePrecheckDto
  status: 200
}

export type routesControllerArchivePrecheckResponse401 = {
  data: void
  status: 401
}

export type routesControllerArchivePrecheckResponse403 = {
  data: void
  status: 403
}

export type routesControllerArchivePrecheckResponse404 = {
  data: void
  status: 404
}

export type routesControllerArchivePrecheckResponseSuccess = (routesControllerArchivePrecheckResponse200) & {
  headers: Headers;
};
export type routesControllerArchivePrecheckResponseError = (routesControllerArchivePrecheckResponse401 | routesControllerArchivePrecheckResponse403 | routesControllerArchivePrecheckResponse404) & {
  headers: Headers;
};

export type routesControllerArchivePrecheckResponse = (routesControllerArchivePrecheckResponseSuccess | routesControllerArchivePrecheckResponseError)

export const getRoutesControllerArchivePrecheckUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}/archive-precheck`
}

/**
 * Counts the unarchived work orders currently assigned to this route by status. n_draft counts draft + redrafting rows; will_clear (n_draft + n_scheduled) is how many work orders would lose the route assignment on archive. In Progress / Completed rows keep the route.
 * @summary Pre-check a route archive
 */
export const routesControllerArchivePrecheck = async (partnerId: string,
    routeId: string, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerArchivePrecheckResponse> => {

  return customFetch<routesControllerArchivePrecheckResponse>(getRoutesControllerArchivePrecheckUrl(partnerId,routeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRoutesControllerArchivePrecheckQueryKey = (partnerId: string,
    routeId: string,) => {
    return [
    `/partners/${partnerId}/routes/${routeId}/archive-precheck`
    ] as const;
    }


export const getRoutesControllerArchivePrecheckQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerArchivePrecheckQueryKey(partnerId,routeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>> = ({ signal }) => routesControllerArchivePrecheck(partnerId,routeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && routeId !== null && routeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerArchivePrecheckQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>>
export type RoutesControllerArchivePrecheckQueryError = void


export function useRoutesControllerArchivePrecheck<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerArchivePrecheck>>,
          TError,
          Awaited<ReturnType<typeof routesControllerArchivePrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerArchivePrecheck<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof routesControllerArchivePrecheck>>,
          TError,
          Awaited<ReturnType<typeof routesControllerArchivePrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerArchivePrecheck<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pre-check a route archive
 */

export function useRoutesControllerArchivePrecheck<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerArchivePrecheckQueryOptions(partnerId,routeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Pre-check a route archive
 */
export const prefetchRoutesControllerArchivePrecheckQuery = async <TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    routeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRoutesControllerArchivePrecheckQueryOptions(partnerId,routeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getRoutesControllerArchivePrecheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoutesControllerArchivePrecheckQueryKey(partnerId,routeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>> = ({ signal }) => routesControllerArchivePrecheck(partnerId,routeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoutesControllerArchivePrecheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>>
export type RoutesControllerArchivePrecheckSuspenseQueryError = void


export function useRoutesControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoutesControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pre-check a route archive
 */

export function useRoutesControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    routeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof routesControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoutesControllerArchivePrecheckSuspenseQueryOptions(partnerId,routeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type routesControllerArchiveRouteResponse201 = {
  data: RouteArchiveResultDto
  status: 201
}

export type routesControllerArchiveRouteResponse400 = {
  data: void
  status: 400
}

export type routesControllerArchiveRouteResponse401 = {
  data: void
  status: 401
}

export type routesControllerArchiveRouteResponse403 = {
  data: void
  status: 403
}

export type routesControllerArchiveRouteResponse404 = {
  data: void
  status: 404
}

export type routesControllerArchiveRouteResponse409 = {
  data: void
  status: 409
}

export type routesControllerArchiveRouteResponseSuccess = (routesControllerArchiveRouteResponse201) & {
  headers: Headers;
};
export type routesControllerArchiveRouteResponseError = (routesControllerArchiveRouteResponse400 | routesControllerArchiveRouteResponse401 | routesControllerArchiveRouteResponse403 | routesControllerArchiveRouteResponse404 | routesControllerArchiveRouteResponse409) & {
  headers: Headers;
};

export type routesControllerArchiveRouteResponse = (routesControllerArchiveRouteResponseSuccess | routesControllerArchiveRouteResponseError)

export const getRoutesControllerArchiveRouteUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}/archive`
}

/**
 * Sets archived_at/archived_by and clears route_id from the partner’s unarchived draft / redrafting / scheduled work orders in one transaction. In Progress / Completed work orders keep the route for historical traceability. ENG-743: a factory’s default route cannot be archived (400) — move the default to another route first; a factory’s only route therefore cannot be archived at all. The audit trail records who archived it, when, and the cleared/retained counts at the time.
 * @summary Archive a route
 */
export const routesControllerArchiveRoute = async (partnerId: string,
    routeId: string, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerArchiveRouteResponse> => {

  return customFetch<routesControllerArchiveRouteResponse>(getRoutesControllerArchiveRouteUrl(partnerId,routeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRoutesControllerArchiveRouteMutationKey = () => ['routesControllerArchiveRoute'] as const;

export const getRoutesControllerArchiveRouteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerArchiveRoute>>, TError,RoutesControllerArchiveRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof routesControllerArchiveRoute>>, TError,RoutesControllerArchiveRouteMutationVariables, TContext> => {

const mutationKey = getRoutesControllerArchiveRouteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routesControllerArchiveRoute>>, RoutesControllerArchiveRouteMutationVariables> = (props) => {
          const {partnerId,routeId} = props ?? {};

          return  routesControllerArchiveRoute(partnerId,routeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoutesControllerArchiveRouteMutationResult = NonNullable<Awaited<ReturnType<typeof routesControllerArchiveRoute>>>

    export type RoutesControllerArchiveRouteMutationError = void
    export type RoutesControllerArchiveRouteMutationVariables = {partnerId: string;routeId: string}

    /**
 * @summary Archive a route
 */
export const useRoutesControllerArchiveRoute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerArchiveRoute>>, TError,RoutesControllerArchiveRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routesControllerArchiveRoute>>,
        TError,
        RoutesControllerArchiveRouteMutationVariables,
        TContext
      > => {
      return useMutation(getRoutesControllerArchiveRouteMutationOptions(options), queryClient);
    }
    export type routesControllerUnarchiveRouteResponse201 = {
  data: RouteDetailDto
  status: 201
}

export type routesControllerUnarchiveRouteResponse401 = {
  data: void
  status: 401
}

export type routesControllerUnarchiveRouteResponse403 = {
  data: void
  status: 403
}

export type routesControllerUnarchiveRouteResponse404 = {
  data: void
  status: 404
}

export type routesControllerUnarchiveRouteResponse409 = {
  data: void
  status: 409
}

export type routesControllerUnarchiveRouteResponseSuccess = (routesControllerUnarchiveRouteResponse201) & {
  headers: Headers;
};
export type routesControllerUnarchiveRouteResponseError = (routesControllerUnarchiveRouteResponse401 | routesControllerUnarchiveRouteResponse403 | routesControllerUnarchiveRouteResponse404 | routesControllerUnarchiveRouteResponse409) & {
  headers: Headers;
};

export type routesControllerUnarchiveRouteResponse = (routesControllerUnarchiveRouteResponseSuccess | routesControllerUnarchiveRouteResponseError)

export const getRoutesControllerUnarchiveRouteUrl = (partnerId: string,
    routeId: string,) => {




  return `/partners/${partnerId}/routes/${routeId}/unarchive`
}

/**
 * Clears archived_at, re-entering the route into the partner’s active-name uniqueness — a conflict with another active route returns 409. Work orders cleared during archive are NOT re-assigned.
 * @summary Unarchive a route
 */
export const routesControllerUnarchiveRoute = async (partnerId: string,
    routeId: string, options?: Parameters<typeof customFetch>[1]): Promise<routesControllerUnarchiveRouteResponse> => {

  return customFetch<routesControllerUnarchiveRouteResponse>(getRoutesControllerUnarchiveRouteUrl(partnerId,routeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRoutesControllerUnarchiveRouteMutationKey = () => ['routesControllerUnarchiveRoute'] as const;

export const getRoutesControllerUnarchiveRouteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>, TError,RoutesControllerUnarchiveRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>, TError,RoutesControllerUnarchiveRouteMutationVariables, TContext> => {

const mutationKey = getRoutesControllerUnarchiveRouteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>, RoutesControllerUnarchiveRouteMutationVariables> = (props) => {
          const {partnerId,routeId} = props ?? {};

          return  routesControllerUnarchiveRoute(partnerId,routeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoutesControllerUnarchiveRouteMutationResult = NonNullable<Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>>

    export type RoutesControllerUnarchiveRouteMutationError = void
    export type RoutesControllerUnarchiveRouteMutationVariables = {partnerId: string;routeId: string}

    /**
 * @summary Unarchive a route
 */
export const useRoutesControllerUnarchiveRoute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>, TError,RoutesControllerUnarchiveRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routesControllerUnarchiveRoute>>,
        TError,
        RoutesControllerUnarchiveRouteMutationVariables,
        TContext
      > => {
      return useMutation(getRoutesControllerUnarchiveRouteMutationOptions(options), queryClient);
    }
